import {GenOutageDataUtility} from '../../../../../generated/serverModels/GenOutageDataUtility';

export class Utility extends GenOutageDataUtility {}
